<template>
  <div class="yd-table-footer flex-1 color-bg-fff">
    <el-table
      v-if="list.length > 0"
      ref="footerTableRef"
      style="width: 100%"
      :size="tableSize"
      :show-header="false"
      :border="tableBorder"
      :stripe="stripe"
      v-bind="$attrs"
      v-on="$listeners"
      :data="list"
      :row-key="rowKey"
    >
      <template v-for="item in renderColumns">
        <template v-if="item.children && item.children.length > 0">
          <TableCOlumnItem :key="item.prop" :item="item" />
        </template>
        <el-table-column v-else :key="item.prop" v-bind="item">
          <template v-if="item.tips" #header>
            <TableColumnTip :align="item.align" :label="item.label" :content="item.tips" />
          </template>
          <template v-if="item.prop === 'sortIndex'" #default="{ $index }">
            <span>{{ index + $index + 1 }}</span>
          </template>
          <template v-else #default="{ row }">
            <slot :name="item.prop" :item="row">
              <div class="content">
                {{ row[item.prop] }}
              </div>
            </slot>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <ScrollBox :scrollLeft="scrollLeft" :tableWidth="tableWidth" :setScrollLeft="setScrollLeft" />
    <Pagination :initPages="pageState">
      <template
        v-for="slot in Object.keys({ ...$scopedSlots, ...$slots })"
        :slot="slot"
        slot-scope="scope"
      >
        <slot :name="slot" v-bind="scope"></slot>
      </template>
    </Pagination>
  </div>
</template>
<script >
import { ref, watch, watchEffect, shallowRef, onBeforeUnmount } from '@vue/composition-api';
import Pagination from './pagination.vue';
import ScrollBox from './scroll-box.vue';
import { on, off } from '@/util';
import { throttle } from 'lodash-es';
const __sfc_main = {};
__sfc_main.props = {
  list: {
    type: Array,
    default: () => []
  },
  index: {
    type: Number,
    default: 0
  },
  stripe: {
    type: Boolean,
    default: true
  },
  height: {
    type: Number
  },
  renderColumns: {
    type: Array,
    default: () => []
  },
  tableSize: {
    type: String,
    default: 'medium'
  },
  tableBorder: {
    type: Boolean,
    default: false
  },
  tableWidth: {
    type: Number,
    default: 0
  },
  scrollLeft: {
    type: Number,
    default: 0
  },
  setScrollLeft: {
    type: Function,
    default: () => {}
  },
  pageState: {
    type: Object,
    default: () => ({})
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const footerTableRef = shallowRef(null);
  const scrollEl = ref(null);
  watchEffect(() => {
    if (scrollEl.value) {
      scrollEl.value.scroll({
        top: 0,
        left: props.scrollLeft || 0
      });
    }
  });
  const onScroll = throttle(e => {
    props.setScrollLeft(e.target.scrollLeft);
  }, 16);
  watch(footerTableRef, v => {
    if (v) {
      scrollEl.value = v.$el.querySelector('.el-table__body-wrapper');
      on(scrollEl.value, 'scroll', onScroll);
    }
  }, {
    immediate: true
  });
  onBeforeUnmount(() => {
    if (scrollEl.value) {
      off(scrollEl.value, 'scroll', onScroll);
    }
  });
  return {
    footerTableRef
  };
};
__sfc_main.components = Object.assign({
  ScrollBox,
  Pagination
}, __sfc_main.components);
export default __sfc_main;
</script>
<style scoped lang="scss">
  .yd-table-footer {
    position: sticky;
    bottom: 0;
    left: 0;
    z-index: 100;
    box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.05);
  }
  .content {
    white-space: wrap;
  }
</style>
